import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Fee } from '../models/Fee';
@Injectable()
export class FeeService {
  private readonly FeeEndpoint = '/api/fee/';
  headers: any;
  constructor(private http: HttpClient) { }
  addFee(fee: any) {
    console.log(fee);
    return this.http.post(this.FeeEndpoint + "AddFee/", fee);
  }
  getFee(fee: any) {
    return this.http.post(this.FeeEndpoint + "GetFee/", fee);
  }
  getFeeA(fee: any) {
     
    return this.http.post(this.FeeEndpoint + "GetFeeA/", fee);
  }
  getAllFee(fee: any) {
    return this.http.post(this.FeeEndpoint + "GetFee/", fee);
  }
  getOldFees(studentID: string, semester: string) {
    return this.http.get(this.FeeEndpoint + `GetOldFees/${studentID}/${semester}`);
  }
  deleteFee(feeID: string) {
    return this.http.delete(this.FeeEndpoint + `DeleteFee/${feeID}`);
  }
  editFee(fee: any) {
    return this.http.put(this.FeeEndpoint + "EditFee/", fee);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/FeeService.ts